import { Component, OnInit, ViewChild, Injector, AfterViewInit } from "@angular/core";
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
import {
    animate,
    keyframes,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';

@Component({
    selector: "[socialMediaToastrContent]",
    template: require('./socialMediaToastr.component.html'),
    styles: [require('./socialMediaToastr.component.css')],
    animations: [
        trigger('flyInOut', [
            state('inactive', style({
                
                opacity: 0
            })),
            state('active', style({ opacity: 100 })),
            state('removed', style({ opacity: 0 })),
            transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
            transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
        ]),
    ],
    preserveWhitespaces: false,
})


export class socialMediaToastrComponent extends Toast {
   

    // constructor is only necessary when not using AoT
    constructor(
        protected toastrService: ToastrService,
        public toastPackage: ToastPackage,
    ) {
        super(toastrService, toastPackage);
        console.log('socialMediaToastrComonent:constructor, message: ' + this.message)
    }

    action(event: Event) {
        event.stopPropagation();
       
        this.toastPackage.triggerAction();
        return false;
    }
}

